export const DISTRICT_QUERY_PREFIX = 'districts';
export const INDUSTRY_QUERY_PREFIX = 'industries';
export const LANGUAGE_QUERY_PREFIX = 'languages';
export const OCCUPATION_QUERY_PREFIX = 'occupations';
export const PROVINCE_QUERY_PREFIX = 'provinces';

export const PROVINCE_QUERY_KEY = {
	all: [ PROVINCE_QUERY_PREFIX ],

	list: (region: string) => [ PROVINCE_QUERY_PREFIX, 'list', region ],
};

export const DISTRICT_QUERY_KEY = {
	all: [ DISTRICT_QUERY_PREFIX ],

	list: (provinceId: string) => [ DISTRICT_QUERY_PREFIX, 'list', provinceId ],
};

export const LANGUAGE_QUERY_KEY = {
	all:  [ LANGUAGE_QUERY_PREFIX ],
	list: [ LANGUAGE_QUERY_PREFIX, 'list' ],

	detail: (languageId?: string) => [ LANGUAGE_QUERY_PREFIX, 'detail', languageId ],
};

export const INDUSTRY_QUERY_KEY = {
	all:   [ INDUSTRY_QUERY_PREFIX ],
	roots: [ INDUSTRY_QUERY_PREFIX, 'list-roots' ],

	children: (industryId: string) => [ INDUSTRY_QUERY_PREFIX, 'list-children-by-id', industryId ],
};

export const OCCUPATION_QUERY_KEY = {
	all:   [ OCCUPATION_QUERY_PREFIX ],
	roots: [ OCCUPATION_QUERY_PREFIX, 'list-roots' ],

	children: (occupationId: string) => [ OCCUPATION_QUERY_PREFIX, 'list-children-by-id', occupationId ],
};
